import { render, staticRenderFns } from "./PrevisionClientCard.vue?vue&type=template&id=2d10e5fb&"
import script from "./PrevisionClientCard.vue?vue&type=script&lang=js&"
export * from "./PrevisionClientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports